/**
 * Classification Badge Component - Displays message type with color coding
 */

import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { MessageType } from '@/types/enums';
import { getMessageTypeInfo } from '@/utils/messageTypes';

interface ClassificationBadgeProps {
  type: MessageType;
  size?: 'small' | 'medium';
  showIcon?: boolean;
}

const ClassificationBadge: React.FC<ClassificationBadgeProps> = ({
  type,
  size = 'small',
  showIcon = true,
}) => {
  const info = getMessageTypeInfo(type);

  return (
    <Tooltip title={info.description} arrow>
      <Chip
        label={
          showIcon ? (
            <>
              {info.icon} {info.label}
            </>
          ) : (
            info.label
          )
        }
        size={size}
        sx={{
          backgroundColor: info.color,
          color: '#fff',
          fontWeight: 500,
          '&:hover': {
            backgroundColor: info.color,
            opacity: 0.9,
          },
        }}
      />
    </Tooltip>
  );
};

export default ClassificationBadge;
